import { IUser } from "./IUser.type";

export enum UserDependentType {
  CHILD = "child",
  PARTNER = "partner",
  EMPTY = "",
}

export interface UserDependent {
  id?: string;
  firstName: string;
  lastName: string;
  deTaxId?: string;
  birthDate: string;
  marriageStartDate?: string;
  marriageEndDate?: string;
  type: UserDependentType;
}

export interface VatMetaNote {
  createdAt: string;
  updatedAt: string;
  message: string;
  creator: string;
  id: number;
  editable?: boolean;
}

export interface VatDeclaration {
  id: string;
  amount: number;
  year: number;
  period: string;
  uploadedAt: string;
}

export type VatSubmissionTransmissionMethod = "AUTOMATIC" | "MANUAL";

export interface VatSubmissionEntry {
  id: number;
  amount: number | null;
  period: string;
  year: number;
  uploadedAt: string | null;
  createdAt: string;
  isCorrection: boolean;
  transmissionMethod: VatSubmissionTransmissionMethod;
  submitterEmail: string | null;
}

export interface VatMeta {
  notes: VatMetaNote[];
  pastDeclarations: VatDeclaration[];
  user: IUser | null;
}
